import { IColumn } from "@fluentui/react";
import React, { ReactElement } from "react";
import {
    ListTableColumn,
    createListTableColumns,
    renderDateTime,
    ensure,
    Link,
    Text,
    renderOptionalName
} from "sprint-common-web";

import {
    resolveOrderContentTitle,
    resolveOrderContentVersion
} from "../../../common/api/orders-api/order/ContentReference";
import { renderContent } from "../../../orders/common/components/listings/renderContent";
import { LookupOrderItem } from "./LookupOrderItem";

interface CreateLookupOrdersListColumnsProps {
    onClick: (item: LookupOrderItem) => void;
}

export const createLookupOrdersListColumns = (
    props: CreateLookupOrdersListColumnsProps
): ListTableColumn<LookupOrderItem>[] => {
    return createListTableColumns<LookupOrderItem>([
        {
            type: "interactive",
            key: "pONumber",
            name: "PO Number",
            minWidth: 100,
            maxWidth: 230,
            isResizable: true,
            isSortable: true,
            onItemInvoked: props.onClick,
            onRender: renderObjectTitle
        },
        {
            type: "basic",
            key: "content",
            name: "Content",
            minWidth: 120,
            maxWidth: 300,
            isResizable: true,
            isSortable: true,
            onRender: renderAssociateContent
        },
        {
            type: "basic",
            key: "airline",
            name: "Airline",
            minWidth: 80,
            maxWidth: 200,
            isResizable: true,
            isSortable: true,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "system",
            name: "System",
            minWidth: 48,
            maxWidth: 100,
            isResizable: true,
            isSortable: true,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "createdDate",
            name: "Created",
            minWidth: 110,
            maxWidth: 110,
            isSortable: true,
            isResizable: true,
            onRender: renderDateTime
        }
    ]);
};

const isActionDisabled = (item: LookupOrderItem) => !item.content || !item.airline;

const renderObjectTitle = (
    item?: LookupOrderItem,
    _index?: number,
    column?: ListTableColumn<unknown> & IColumn
): ReactElement | null => {
    ensure(item);
    ensure(column);
    ensure(column.currentWidth);

    const onClick = () => column.onItemInvoked && column.onItemInvoked(item);

    return (
        <Link
            onClick={onClick}
            styles={{
                root: { width: "100%" }
            }}
            disabled={isActionDisabled(item)}
        >
            <Text testId="order-lookup-listing-pONumber" value={item.pONumber} variant="smallPlus" />
        </Link>
    );
};

const renderAssociateContent = (item?: LookupOrderItem) => {
    ensure(item);

    return renderContent({
        content: item.content ? resolveOrderContentTitle(item.content) : undefined,
        version: item.content ? resolveOrderContentVersion(item.content) : undefined
    });
};
